export function getSampleContracts() {
  return [
    { id: "C-001", title: "Sample Contract 1", status: "Draft" },
    { id: "C-002", title: "Sample Contract 2", status: "Active" },
    { id: "C-003", title: "Sample Contract 3", status: "Expired" },
  ];
}
